import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=3e7fb8ad&"
import script from "./BlogItem.vue?vue&type=script&lang=js&"
export * from "./BlogItem.vue?vue&type=script&lang=js&"
import style0 from "./BlogItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports